import { useContext } from 'react';
import { OpenAPI } from '@rbx/docsite-utilities/dist/browser';
import { OpenAPIDocumentContext } from '../context/DocumentProvider';

/**
 * Hook to access the OpenAPI document from context
 * Must be used within an OpenAPIDocumentProvider
 */
export function useOpenAPIDocument(): OpenAPI.Document {
  const document = useContext(OpenAPIDocumentContext);

  if (!document) {
    throw new Error('useOpenAPIDocument must be used within an OpenAPIDocumentProvider');
  }

  return document;
}

export default useOpenAPIDocument;
